import {
  UPDATE_PRODUCT_PAGE_NUMBER,
  GET_PRODUCT_PENDING,
  GET_PRODUCT,
  GET_PRODUCT_SELECT,
  DELETE_PRODUCT,
  FETCH_PRODUCT,
  EDIT_PRODUCT,
  ADD_PRODUCT,
  CLEAR_PRODUCT,
  RESET_PRODUCT,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  products: [],
  select_list: [],
  pending: false,
  pageNumber: 1,
  deleted: false,
  updated: false,
  created: false,
};

export default function Product(state = initialState, action) {
  switch (action.type) {
    case GET_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case UPDATE_PRODUCT_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case GET_PRODUCT:
      return {
        ...state,
        products: action.payload,
        pending: false,
      };
    case GET_PRODUCT_SELECT:
      return {
        ...state,
        select_list: action.payload,
        pending: false,
      };
    case FETCH_PRODUCT:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };

    case EDIT_PRODUCT:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };

    case DELETE_PRODUCT:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };

    case ADD_PRODUCT:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };

    case RESET_PRODUCT:
      return {
        ...state,
        deleted: false,
        updated: false,
        created: false,
        pending: false,
      };

    case CLEAR_PRODUCT:
      return {
        ...state,
        ...initialState,
      };

    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
